import React, { useState } from 'react';
import { ProductImage } from '../../types';
import './ImageGallery.css';

interface ImageGalleryProps {
  images: ProductImage[];
  productName: string;
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images, productName }) => {
  const [selectedImage, setSelectedImage] = useState(0);

  if (!images || images.length === 0) {
    return (
      <div className="image-gallery">
        <div className="main-image">
          <img src="/placeholder-product.png" alt={productName} />
        </div>
      </div>
    );
  }

  return (
    <div className="image-gallery">
      <div className="main-image">
        <img 
          src={images[selectedImage].image} 
          alt={`${productName} - ${selectedImage + 1}`}
        />
      </div>

      {images.length > 1 && (
        <div className="thumbnail-list">
          {images.map((image, index) => (
            <div
              key={image.id}
              className={`thumbnail ${index === selectedImage ? 'active' : ''}`}
              onClick={() => setSelectedImage(index)}
            >
              <img src={image.image} alt={`${productName} thumbnail ${index + 1}`} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageGallery;
